module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fb5cf9e240a84ac8aa1e41a56e48701d.png";